import React from "react"
import Seo from "../../components/seo"
import Layout from "../../components/layout"
import KeyMethodLink from "../../components/key-method-link"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import { Link } from "gatsby"
import "../../styles/pc/page/key_method.scss"
import "../../styles/sp/page/key_method.scss"

export default function ConnectionPowerPage() {
  return (
    <Layout>
      <Seo
        type="article"
        title="それぞれのKeyMethodの紹介 つながり力"
        description=""
        bobyClassName="menu20"
        path="key-method/connection-power"
      />
      <div className="wrapper">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/philosophy#terms-section">用語集</Link>　/　<Link to="/key-method/connection-power" className="current">つながり力</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        <div className="wrapper_contents">
          <div className="main">
            {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
            <div className="contents contents_wrap">
              <div className="contents_in">
                <div className="padding_sp">{/* スマホのみ隙間 */}
                  <div className="wrap_box w670">
                    <div className="inner_title">
                      <div className="inner_title_in">
                        <h5 className="maintitle_left"><span>つながり力</span></h5>
                      </div>
                    </div>
                    <div className="cnt_box">
                      <p className="read"><span className="redBold">「組織力」は、「個人の力」と「つながりの力」の掛け算</span>で決まります。</p>
                      <p>個々人の力は、能力×やる気だと言われます。<br />
                        個々人が自分の知識やスキルを伸ばし、やる気を高めることは大切です。</p>
                      <p>ただ、私たちは人が力を発揮するためには、やる気だけでなく、安心感や支え合い感、認め合い感といった温かい感情や、ときには強い緊張感、不安感も必要だと思っています。こうした感情を引き出し、自分の力に変えていく力、これが感情力です。</p>
                      <p>つまり、<span className="redBold">個人の力は、能力×感情力</span>で決まると考えています。</p>
                      <p>でも、いくら個々人の力だけが高まっても、組織力は高まりません。<br />
                        大切なのは、個々人の力をつなぐこと、重ね合わせることです。</p>
                      <p>この「<span className="greenBold">つながり力</span>」にも、二つの要素があります。</p>
                      <p>まずは、<span className="redBold">みんなが一つにまとまる力</span>です。一体感や連帯感というものです。<br />
                        これは、何かを一緒に乗り越えていく体験が共有されていけば、高まっていきます。</p>
                      <p>でも、それ以上に大切な力があります。それは<span className="redBold">一人ひとりがつながる力</span>です。<br />
                        一人ひとりが、お互いのことを考え、支援し合う。<br />
                        その中で、自分が必要とされているという効力感、実感を得ていく。<br />
                        これが、利他的な行動を引き出し、自分の能力や限界を超えた行動を<br />
                        引き出していきます。</p>
                      <p>一人ひとりがつながる力。<br />
                        これが、強い組織をつくるために、必要であると考えます。</p>
                        <LazyAndPreloadImage className="Img_key-method" imgUrl={"/images/key-method/image_keyconcept5.gif"} alt="組織力 ＝ 個人力 ×  つながり力" />
                      <div className="flex_box bottom_56px">
                        <ul className="box">
                          <li>能力<br />
                            （知識、スキル、経験）</li>
                          <li>感情力<br />
                            （感じる力、内発力、共感力）</li>
                        </ul>
                        <ul className="box">
                          <li>一つにまとまる力<br />
                            （一体感、連帯感）</li>
                          <li>一人ひとりがつながる力<br />
                            （支援力、認め合う力）</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>{/* padding_sp スマホのみ隙間 */}
              </div>{/* contents_in */}
            </div>{/* /contents */}
            {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
            <KeyMethodLink />
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">Key Method - </span><span className="txt">キーメソッド</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}
